import { Forbidden } from '../Forbidden';
import { ClassifierMappingMutate } from './ClassifierMappingMutate';
import {
  ClassifierMappingsFormDataType,
  PermissionCode,
  useHasPermission,
} from '@atlas-frontend/sdk';

const defaultValues: Omit<
  ClassifierMappingsFormDataType,
  'classifierFrom' | 'classifierTo'
> = {
  createdAt: null,
  createdBy: null,
  id: undefined!,
  modifiedAt: null,
  modifiedBy: null,
  code: '',
  name: '',
  categoryMappings: [],
  description: '',
  classifierIdFrom: '' as any,
  classifierIdTo: '' as any,
};

export interface ClassifierMappingFormProps {
  data?: ClassifierMappingsFormDataType;
  mode: 'edit' | 'clone' | 'create';
  readOnly?: boolean;
  onSuccess?: () => void;
}

export const ClassifierMappingForm = ({
  data,
  mode,
  readOnly,
  onSuccess,
}: ClassifierMappingFormProps) => (
  <Forbidden isAllowed={useHasPermission(PermissionCode.CLASSIFIER_MANAGE)}>
    <ClassifierMappingMutate
      mode={mode}
      data={data ?? defaultValues}
      readOnly={readOnly}
      onSuccess={onSuccess}
    />
  </Forbidden>
);
